import type { PackageDirectionType } from '@/features/package/domain/enums/PackageDirectionType'
import type { PackageItemType } from '@/features/package/domain/enums/PackageItemType'
import type { PackageStatus } from '@/features/package/domain/enums/PackageStatus'
import type { OrderPaymentType } from '@/features/order/domain/enums/OrderPaymentType'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'

export class LivePackageEntity {
  id?: string
  user?: {
    id?: string
    displayName?: string | null
    phoneNumber?: string | null
  }
  serviceId?: number
  serviceName?: string | null
  status?: PackageStatus
  statusUpdatedAt?: string
  deliveryFeePrice?: number
  invoice?: {
    paymentType?: OrderPaymentType
  }
  senderName?: string | null
  senderPhoneNumber?: string | null
  receiverName?: string | null
  receiverPhoneNumber?: string | null
  directionType?: PackageDirectionType
  vehicleTemplateType?: VehicleTemplateType | null
  itemType?: PackageItemType
  referenceCode?: string | null
  createdAt?: string
  trackingPanelUserId?: string | null
  trackingPanelUserDisplayName?: string | null
  assignedDriver?: AssignedDriverEntity
}

export class AssignedDriverEntity {
  id?: number
  workingPhoneNumber?: string | null
  fullName?: string | null
  avatarImagePath?: string | null
}
